module.exports = __webpack_public_path__ + "static/img/logo15.5e710fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo15.png
// module id = 9tqz
// module chunks = 1